import React, { CSSProperties } from 'react'
import classNames from 'classnames'

import { Text, TextName } from 'sdk'

import classes from './CapabilitiesCard.module.scss'

interface CapabilitiesCardProps {
  title: React.ReactNode
  desktopImage: string
  mobileImage: string
  className?: string
}

type BackgroundStyles = CSSProperties & {
  '--desktop-image': string
  '--mobile-image': string
}

export const CapabilitiesCard: React.FC<CapabilitiesCardProps> = ({
  title,
  desktopImage,
  mobileImage,
  className,
}) => {
  const backgroundStyles: BackgroundStyles = {
    '--desktop-image': `url(${desktopImage})`,
    '--mobile-image': `url(${mobileImage})`,
  }

  return (
    <div
      className={classNames(classes.capabilitiesCard, className)}
      style={backgroundStyles}
    >
      <Text type={TextName.H3} className={classes.title}>
        {title}
      </Text>
    </div>
  )
}

